<template>
  <div class="cms-detail-overlay" @click.self="closePanel">
    <article id="topic-detail" class="topic-detail cms-detail-panel">
      <div class="news-detail-head">
        <div>
          <span>{{ front.moduleLabel(item.moduleCode) }}</span>
          <h3>{{ item.title }}</h3>
          <time>{{ isGallery ? `历史时间：${item.date || '未设置'}` : (item.date || '待发布') }}</time>
        </div>
        <button type="button" class="text-link" @click="closePanel">关闭</button>
      </div>
      <img v-if="item.coverUrl" :src="front.resolvePublicDisplayUrl(item.coverUrl)" alt="" />
      <p v-if="item.summary" class="news-summary">{{ item.summary }}</p>
      <section v-if="galleryImportantEvent" class="gallery-event-detail">
        <strong>重要事件</strong>
        <p>{{ galleryImportantEvent }}</p>
      </section>
      <div v-if="item.bodyContent" class="news-body" v-html="item.bodyContent"></div>
      <div v-else-if="!isGallery" class="news-body">暂无正文内容</div>
      <div v-if="attachments.length" class="news-attachments">
        <div class="news-attachments__title">附件下载</div>
        <ul class="news-attachments__list">
          <li v-for="(file, index) in attachments" :key="file.id || file.url || index" class="attachment-item">
            <div class="attachment-item__main">
              <span v-if="categoryLabel(file.category)" class="attachment-category">{{ categoryLabel(file.category) }}</span>
              <button type="button" class="attachment-link" @click="front.downloadEntryAttachment(item, file)">
                {{ file.name || front.fileNameFromUrl(file.url) }}
              </button>
            </div>
            <small v-if="originalNameOf(file)" class="attachment-original">{{ originalNameOf(file) }}</small>
          </li>
        </ul>
      </div>
      <div v-else-if="item.linkUrl" class="news-external">
        <p>该内容为外部链接，已尝试在新窗口打开。</p>
        <a :href="item.linkUrl" target="_blank" rel="noopener noreferrer" class="primary-action compact">访问外链</a>
      </div>
    </article>
  </div>
</template>

<script>
import { getGalleryImportantEvent } from '../../utils/cmsExtra'

export default {
  name: 'CmsEntryDetailPanel',
  inject: ['front'],
  computed: {
    item() {
      return this.front.selectedCmsEntry || {}
    },
    attachments() {
      const list = this.front.entryAttachments
        ? this.front.entryAttachments(this.item)
        : []
      if (list.length) {
        return list
      }
      const url = this.item.mediaUrl
      return url ? [{ id: 'primary', name: '', url }] : []
    },
    isGallery() {
      return this.item.moduleCode === 'gallery'
    },
    galleryImportantEvent() {
      if (!this.isGallery) return ''
      return String(this.item.importantEvent || getGalleryImportantEvent(this.item) || '').trim()
    }
  },
  methods: {
    closePanel() {
      this.front.selectedCmsEntry = null
    },
    categoryLabel(category) {
      const map = {
        document: '文档',
        audio: '音频',
        video: '视频',
        photo: '照片'
      }
      return map[String(category || '').toLowerCase()] || ''
    },
    originalNameOf(file) {
      const original = String((file && file.originalName) || '').trim()
      const name = String((file && file.name) || '').trim()
      return original && name && original !== name ? original : ''
    }
  }
}
</script>

<style scoped>
.cms-detail-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 80px 24px 24px;
  background: rgba(0, 29, 54, 0.52);
  overflow-y: auto;
}

.cms-detail-panel {
  width: min(860px, 100%);
  margin: 0;
  border: 1px solid var(--border);
  border-top: 3px solid var(--primary);
  border-radius: var(--front-radius);
  padding: 26px 28px 32px;
  background: #fff;
  box-shadow: 0 18px 48px rgba(0, 29, 54, 0.18);
}

.gallery-event-detail {
  margin: 18px 0 0;
  border-left: 4px solid var(--gold);
  border-radius: 6px;
  padding: 14px 16px;
  background: #f8f5ee;
}

.gallery-event-detail strong {
  color: var(--primary);
  font-size: 15px;
}

.gallery-event-detail p {
  margin: 7px 0 0;
  color: var(--ink);
  line-height: 1.8;
  white-space: pre-line;
}
</style>
